"use strict";
/**
 * sl-sbpf.1: View Component Type Constants — canonical source.
 *
 * Single Source of Truth for all component type identifiers. Lives in
 * @streamlain/view-config so that schema validation (page-presets),
 * the app-base CSS contract, and both renderers (authoring +
 * SSR) derive from one list. The frontend-core module
 * `modules/streamlain/constants/view-component-types` re-exports this.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_COMPONENT_TYPE_VALUES = exports.VIEW_COMPONENT_TYPES = void 0;
exports.isViewComponentType = isViewComponentType;
exports.VIEW_COMPONENT_TYPES = {
    // Content
    CARD_GRID: 'card-grid',
    ARTICLE_LIST: 'article-list',
    TABLE_VIEW: 'table-view',
    SINGLE_ARTICLE: 'single-article',
    MARKDOWN_RENDERER: 'markdown-renderer',
    CUSTOM_HTML_BLOCK: 'custom-html-block',
    HERO_BANNER: 'hero-banner',
    RELATED_ENTRIES: 'related-entries',
    TAG_DISPLAY: 'tag-display',
    // Data
    KPI_CARD: 'kpi-card',
    BAR_CHART: 'bar-chart',
    LINE_CHART: 'line-chart',
    // Widget
    FORM_VIEW: 'form-view',
    // Navigation
    BREADCRUMB: 'breadcrumb',
    PAGINATION: 'pagination',
    FILTER_BAR: 'filter-bar',
    SEARCH_BAR: 'search-bar',
    LANGUAGE_SWITCHER: 'language-switcher',
    APP_BASE_NAVIGATION: 'app-base-navigation',
    APP_BASE_HEADER: 'app-base-header',
    APP_BASE_FOOTER: 'app-base-footer',
    // Container
    SECTION: 'section',
    GRID_2: 'grid-2',
    GRID_3: 'grid-3',
};
exports.VIEW_COMPONENT_TYPE_VALUES = Object.values(exports.VIEW_COMPONENT_TYPES);
function isViewComponentType(value) {
    return exports.VIEW_COMPONENT_TYPE_VALUES.includes(value);
}
